import React, { createContext, useState } from 'react'

export const LoadingContext = createContext()

// Rendered inside wrapRootElement, which Gatsby also applies to <head>, so this must not render UI.
const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export default LoadingProvider
